<template>
  <div class="pb-5">
    <v-app-bar
      flat
      color="transparent"
      class="main-appbar"
    >
      <app-bar-nav-icon />
      <v-toolbar-title>
        <h1 class="headline font-weight-bold">Sports Betting 101</h1>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-row
        v-if="showSearch"
        align="center"
        style="max-width: 300px;"
      >
        <v-text-field
          flat
          hide-details
          single-line
          label="Search article title"
          class="hidden-sm-and-down"
          v-model="filter.search"
          @input="search"
        ></v-text-field>
      </v-row>
      <v-btn
        class="ml-5"
        icon
        @click="showSearch = !showSearch"
      >
        <img
          src="@/assets/icons/search.svg"
          alt
        />
      </v-btn>

      <div>

      </div>
    </v-app-bar>

    <v-card flat>
      <!-- <div class="ma-4 text-right">
        <v-chip>Total: {{ listMeta.total }}</v-chip>
      </div> -->
      <div
        class="pa-4"
        id="sport-betting-list"
      >
        <v-row>
          <v-col
            cols="12"
            md="3"
          >
            <v-autocomplete
              :items="categories"
              v-model="category_filter"
              clearable
              outlined
              label="Category"
              @input="clearRecordList(), sortTable('custom_order_index')"
            ></v-autocomplete>
          </v-col>

          <v-col
            cols="12"
            md="9"
            align="end"
          >
            <v-btn
              v-if="category_filter && !filter.search"
              :disabled="loading"
              color="primary"
              medium
              style="text-transform: none;"
              @click="onSaveOrder()"
            >Save Article Order</v-btn>
          </v-col>

          <!-- <v-col
            cols="12"
            md="3"
          >
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  large
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  class="ml-3"
                  @click="category_filter = null, fetchSportBettingArticles(1)"
                >
                  <v-icon>mdi-refresh</v-icon>
                </v-btn>
              </template>
              <span>Reset filter</span>
            </v-tooltip>
          </v-col> -->
        </v-row>
        <div
          class="mt-12 mx-4"
          id="sb-article-list"
          v-infinite-scroll="loadMore"
          :infinite-scroll-disabled="loading"
          infinite-scroll-distance="100"
        >
          <v-simple-table>
            <thead>
              <tr>
                <th>
                  <div class="d-flex justify-center justify-space-between">
                    Title
                  </div>
                </th>
                <th class="text-left">
                  <div class="d-flex justify-center justify-space-between">
                    Author
                  </div>
                </th>
                <th class="text-left">Category</th>
                <th class="text-left">Tags</th>
                <!-- <th
                width="10%"
                class="text-left"
              >
                <div class="d-flex justify-center justify-space-between">
                  Added Date
                </div>
              </th> -->
                <th
                  class="text-left"
                  @click="sortTable('created_at')"
                >
                  <div class="d-flex justify-left hoverable">
                    Added Date
                    <v-icon
                      small
                      color="blue darken-2"
                      v-if="tableSort.sortBy === 'created_at'"
                    >{{ tableSort.icon }}</v-icon>
                    <v-icon
                      small
                      color="blue darken-2"
                      v-else
                    >mdi-sort</v-icon>
                  </div>
                </th>
                <th width="10%">Photo</th>
                <th></th>
              </tr>
            </thead>

            <draggable
              v-model="articles"
              group="people"
              @start="drag=true"
              @end="drag=false"
              class="list-group"
              tag="tbody"
            >
              <tr
                v-for="(bettingArticle, index) in articles"
                :key="bettingArticle.id"
                class="hoverable"
              >
                <td @click="viewArticleDetails(bettingArticle.id)">
                  <text-highlight :queries="filter.search">{{ bettingArticle.title }}</text-highlight>
                </td>
                <td @click="viewArticleDetails(bettingArticle.id)">
                  <text-highlight :queries="filter.search">{{ bettingArticle.author }}</text-highlight>
                </td>
                <td
                  @click="viewArticleDetails(bettingArticle.id)"
                  class="capitalize"
                >{{ get(bettingArticle.sport_betting_category, 'name', 'N/A') }}</td>
                <td @click="viewArticleDetails(bettingArticle.id)">
                  <v-chip
                    :key="tag.id"
                    v-for="tag in bettingArticle.tags"
                    class="ma-2"
                  >
                    {{ tag.name }}
                  </v-chip>
                </td>
                <td @click="viewArticleDetails(bettingArticle.id)">{{ bettingArticle.addedDate }}</td>
                <td
                  @click="viewArticleDetails(bettingArticle.id)"
                  class="text-center py-4"
                >
                  <v-card
                    class="d-flex justify-space-between pa-2"
                    max-width="100"
                  >
                    <div>
                      <user-avatar
                        :tile="true"
                        :avatar="bettingArticle.thumbnail"
                        size="60"
                      />
                    </div>

                    <div class="d-inline-block pl-2">
                      <v-tooltip
                        left
                        v-if="bettingArticle.published_date"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            color="success darken-2"
                            small
                          >mdi-book-open-variant</v-icon>
                        </template>
                        <span>{{ bettingArticle.publishedDate }}</span>
                      </v-tooltip>
                    </div>
                  </v-card>
                </td>
                <td class="text-center">
                  <v-menu
                    transition="slide-x-transition"
                    bottom
                    right
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs"
                        v-on="on"
                      >mdi-dots-vertical</v-icon>
                    </template>
                    <v-list>
                      <v-list-item class="hoverable">
                        <v-list-item-title @click="triggerDelete(bettingArticle.id, index)">
                          <v-icon>mdi-delete</v-icon> Delete
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item class="hoverable">
                        <v-list-item-title @click="viewArticleDetails(bettingArticle.id)">
                          <v-icon>mdi-pencil</v-icon> Edit
                        </v-list-item-title>
                      </v-list-item>
                      <!-- <v-list-item>
                      <v-list-item-title>
                        <v-icon>mdi-eye</v-icon> View
                      </v-list-item-title>
                    </v-list-item> -->
                      <v-list-item
                        class="hoverable"
                        v-if="isPublished(bettingArticle.published_date, bettingArticle.unpublished_at)"
                      >
                        <v-list-item-title @click="unPublishSBArticle(bettingArticle.id)">
                          <v-icon>mdi-file-remove</v-icon> Unpublish
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item
                        class="hoverable"
                        v-else
                      >
                        <v-list-item-title @click="publishSBArticle(bettingArticle.id)">
                          <v-icon>mdi-book</v-icon> Publish
                        </v-list-item-title>
                      </v-list-item>

                      <v-list-item @click="previewArticle(bettingArticle)">
                        <v-list-item-title>
                          <v-icon>mdi-eye</v-icon>View
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </td>
              </tr>
              <tr v-if="articles.length == 0">
                <td colspan="12">no records found.</td>
              </tr>
            </draggable>
          </v-simple-table>
        </div>
        <!-- <div
          v-if="listMeta.total"
          class="py-5 d-flex justify-center"
        >
          <small class="grey--text lighten-4">
            {{ listMeta.from }}-{{ listMeta.to }} of
            {{ listMeta.total | formatNumber }}
          </small>
        </div> -->

        <v-overlay
          absolute
          :value="loading"
          opacity="0.1"
        >
          <v-progress-circular
            indeterminate
            color="primary"
            size="64"
          ></v-progress-circular>
        </v-overlay>
      </div>
      <!-- <div
        class="text-center mt-2 mb-8"
        v-if="listMeta.last_page > 1"
      >
        <v-pagination
          @input="pageChanged"
          :value="listMeta.current_page"
          :length="listMeta.last_page"
          :total-visible="10"
          circle
        ></v-pagination>
      </div> -->
    </v-card>

    <v-btn
      color="success"
      fab
      large
      dark
      bottom
      right
      fixed
      class="mx-3 py-2"
      :to="{name: 'sports-betting.create'}"
    >
      <v-icon dark>mdi-plus</v-icon>
    </v-btn>
    <v-dialog
      v-model="confirmDeleteDialog"
      persistent
      max-width="360"
    >
      <v-card>
        <v-card-title class="headline">
          <p class="confirm-delete">Are you sure you want to delete this record?</p>
        </v-card-title>
        <v-card-text>Delete Record.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="confirmDeleteDialog = false"
          >No</v-btn>
          <v-btn
            @click="deleteSBArticle"
            color="red darken-1 white--text"
          >Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snackbar.show"
      right
      :color="snackbar.color"
    >
      {{ snackbar.message }}
      <v-btn
        text
        @click="snackbar.show = false"
      >OK</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { head, get } from 'lodash'
import { mapState, mapActions, mapMutations } from 'vuex'
import {
  mdiDotsVertical,
  mdiUnfoldMoreHorizontal,
  mdiMagnify,
  mdiAccountCircleOutline,
  mdiChevronRight
} from '@mdi/js'
import AppBarNavIcon from '@/layouts/shared/AppBarNavIcon'
import UserAvatar from '@/components/UserAvatar'
import TextHighlight from 'vue-text-highlight'
import debounce from 'lodash/debounce'
import moment from 'moment'
import draggable from 'vuedraggable'
import Form from '@/utils/form'
import map from 'lodash/map'
import infiniteScroll from 'vue-infinite-scroll'

const initialData = {
  page: 1,
  limit: 20,
  sport_betting_ids: [],
  sport_betting_category_id: []

}

export default {
  name: 'SportsBettingPage',

  components: {
    AppBarNavIcon,
    TextHighlight,
    UserAvatar,
    draggable
  },

  directives: {
    infiniteScroll
  },

  data () {
    return {
      loading: false,
      showSearch: false,
      confirmDeleteDialog: false,
      filter: {
        search: ''
      },
      icons: {
        settings: mdiDotsVertical,
        sort: mdiUnfoldMoreHorizontal,
        search: mdiMagnify,
        view: mdiAccountCircleOutline,
        arrow: mdiChevronRight
      },
      to_delete_id: null,
      to_delete_index: null,
      snackbar: {
        show: false,
        message: null,
        color: 'success'
      },
      categoryList: [],
      category_filter: null,
      tableSort: {
        sortBy: 'created_at',
        sortOrder: 'desc',
        sortString: '-created_at',
        icon: 'mdi-sort-alphabetical-descending'
      },
      articles: [],
      form: new Form({
        ...initialData
      }),
    }
  },

  created () {
    this.clearRecordList()
    this.fetchSBCategoryList()
  },

  computed: {
    ...mapState({
      bettingArticlesList: state => state.sportBettingArticles.list,
      listMeta: state => state.sportBettingArticles.listMeta,
      requestStatus: state => state.sportBettingArticles.requestStatus,
      requestMsg: state => state.sportBettingArticles.requestMsg,
      categories: state => state.SBCategory.categoryList
    }),

    paginationLength () {
      return (this.listMeta.total / this.listMeta.per_page) | 0
    }
  },

  methods: {
    head, // Can't be used as computed as it was used in loop
    get, // Can't be used as computed as it was used in loop
    ...mapActions({
      getSportBettingArticles: 'sportBettingArticles/getSportBettingArticles',
      deleteRecord: 'sportBettingArticles/delete',
      publish: 'sportBettingArticles/publish',
      unPublish: 'sportBettingArticles/unpublish',
      getSBCategoryList: 'SBCategory/getList',
      updateOrder: 'sportBettingArticles/updateOrder',
    }),

    ...mapMutations({
      clearRecordList: 'sportBettingArticles/clearList'
    }),

    pageChanged (page) {
      this.fetchSportBettingArticles(page)
    },

    search: debounce(function () {
      this.clearRecordList()
      this.fetchSportBettingArticles()
    }, 600),

    async fetchSportBettingArticles (page = 1) {
      let params = { page }

      params.sort = this.tableSort.sortString
      params.categoryContainingId = this.category_filter

      if (this.filter.search) {
        params.search = this.filter.search
      }
      this.loading = true
      await this.getSportBettingArticles(params)
      this.articles = this.bettingArticlesList
      this.loading = false
    },

    async viewArticleDetails (id) {
      this.editArticle(id)
    },

    editArticle (id) {
      this.$router.push({ name: 'sports-betting.edit', params: { id } })
    },

    triggerDelete (id, index) {
      this.confirmDeleteDialog = true
      this.to_delete_id = id
      this.to_delete_index = index
    },

    async deleteSBArticle () {
      this.loading = true
      this.confirmDeleteDialog = false
      await this.deleteRecord(this.to_delete_id)
        .then(response => {
          this.bettingArticlesList.splice(this.to_delete_index, 1)
          this.showSnackbar(this.requestMsg)
          this.loading = false
        })
        .catch(err => {
          console.log(err)
          this.showSnackbar(this.requestMsg)
        })
    },

    async publishSBArticle (id) {
      this.loading = true

      await this.publish(id)
        .then(response => {
          this.showSnackbar(this.requestMsg)
          this.loading = false
        })
        .catch(err => {
          console.log(err)
          this.showSnackbar(this.requestMsg)
        })

      this.fetchSportBettingArticles()
    },

    async unPublishSBArticle (id) {
      this.loading = true

      await this.unPublish(id)
        .then(response => {
          this.showSnackbar(this.requestMsg)
          this.loading = false
        })
        .catch(err => {
          console.log(err)
          this.showSnackbar(this.requestMsg)
        })

      this.fetchSportBettingArticles()
    },

    showSnackbar (message) {
      this.snackbar.color = this.requestStatus
      this.snackbar.message = message
      this.snackbar.show = true
    },

    isPublished (publishDate, unPublishDate) {
      if (moment(publishDate) > moment(unPublishDate) || (!unPublishDate && publishDate)) {
        return true
      }
      return false
    },

    previewArticle (article) {
      if (article.slug !== null) {
        window.open(process.env.VUE_APP_WEB_URL + '/sports-betting-101/' + article.sport_betting_category.name + '/' + article.slug)
      } else {
        window.open(process.env.VUE_APP_WEB_URL + '/sports-betting-101/' + article.sport_betting_category.name + '/' + article.id)
      }
    },

    async fetchSBCategoryList (page = 1) {
      let params = { page }

      params.sort = '-created_at'
      this.loading = true
      this.loading_message = 'Fetching Data'
      await this.getSBCategoryList(params)

      this.category_filter = this.categories[0].value

      this.fetchSportBettingArticles(1)

    },

    sortTable (sortBy) {
      if ((this.tableSort.sortBy !== sortBy) || this.tableSort.sortBy === 'custom_order_index') {
        this.tableSort.sortBy = sortBy
        this.tableSort.sortOrder = 'asc'
        this.tableSort.sortString = sortBy
        this.tableSort.icon = 'mdi-sort-alphabetical-ascending'
      } else {
        this.tableSort.sortBy = sortBy
        if (this.tableSort.sortOrder === 'asc') {
          this.tableSort.sortOrder = 'desc'
          this.tableSort.sortString = '-' + sortBy
          this.tableSort.icon = 'mdi-sort-alphabetical-descending'
        } else {
          this.tableSort.sortOrder = 'asc'
          this.tableSort.sortString = sortBy
          this.tableSort.icon = 'mdi-sort-alphabetical-ascending'
        }
      }
      this.sortArticles()
    },

    sortArticles: debounce(function () {
      this.fetchSportBettingArticles()
    }, 600),

    async onSaveOrder () {

      try {
        this.form.sport_betting_ids = map(this.articles, item => {
          return item.id
        })
        this.form.sport_betting_category_id = this.category_filter
        this.form.$busy = true
        this.loading = true
        this.form.$clearErrors()
        const data = this.form.$data()

        data._method = 'put'

        await this.updateOrder(data)

        this.showSnackbar(this.requestMsg)
      } catch (error) {
        if (get(error, 'response.status') === 422) {
          if (get(error, 'response.data.errors') !== null) {
            this.form.$setErrors(get(error, 'response.data.errors'))
          } else {
            this.showSnackbar('Something went wrong.')
          }
        } else {
          this.showSnackbar(error)
        }
      } finally {
        this.form.$busy = false
        this.loading = false
      }
    },

    loadMore () {
      if (this.listMeta.current_page < this.listMeta.last_page) {
        this.fetchSportBettingArticles(this.listMeta.current_page + 1)
      }
    },
  },

  filters: {
    formatNumber (value) {
      return Number(value).toLocaleString()
    }
  }

}
</script>

<style scoped>
.hoverable:hover {
  cursor: pointer;
}
.clickable {
  cursor: pointer;
  border-width: 1px;
}
.clickable:hover {
  background-color: #eeeeee;
}
.border-bot {
  border-width: 1px;
  border-bottom: inset;
}
.kebab-menu {
  text-align: end;
}
</style>
